import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Subject, combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ConsentService } from 'app/core/services/consent.service';
import { AuthStateService } from 'app/core/services/auth-state.service';

@Component({
  standalone: true,
  selector: 'app-cookie-consent-banner',
  templateUrl: './cookie-consent-banner.component.html',
  styleUrls: ['./cookie-consent-banner.component.scss'],
  imports: [TranslateModule, RouterModule],
})
export class CookieConsentBannerComponent implements OnInit, OnDestroy {
  isVisible = false;
  private readonly consentService = inject(ConsentService);
  private readonly authState = inject(AuthStateService);
  private destroy$ = new Subject<void>();

  ngOnInit(): void {
    // Only show the banner to a logged-in user who hasn't accepted yet.
    combineLatest([
      this.consentService.hasDecided$,
      this.authState.isAuthenticated$,
    ])
      .pipe(takeUntil(this.destroy$))
      .subscribe(([decided, isAuthenticated]) => {
        this.isVisible = isAuthenticated && !decided;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  accept(): void {
    this.consentService.acceptAll();
  }

  reject(): void {
    this.consentService.rejectAll();
  }
}
